import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatModule } from '../../core';
import { IssuesComponent } from './issues.component';
import { IssuesRoutingModule } from './issues-routing.module';
import { ChartsModule } from '../../shared/charts/charts.module';
import { PieComponent } from './pie/pie.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    IssuesRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatModule,
    ChartsModule
  ],
  declarations: [
    IssuesComponent,
    PieComponent
  ]
})
export class IssuesModule { }
